import { HotKeyDispatcher } from "./HotKeyDispatcher"

export const defaultHotKeyDispatcher = new HotKeyDispatcher()
